import { CustomButton } from '@ui-kit'
import { NAMESPACES } from '../../utils/constants'
import { persist } from '../../utils/agent.store'
import { preserveTableColumn } from '@app-store'

const UserNotFoundPage: React.FC = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-accent-100">
      <div className="bg-accent-0 rounded-lg shadow-md p-6 max-w-md text-center">
        <h1 className="text-base font-medium text-error-500">Access Denied</h1>
        <p className="mt-4 text-accent-600 font-light text-xs">
          You do not have permission to view this page.
        </p>
        <p className="mt-2 text-accent-500 font-light text-xs">
          If you believe this is an error, please contact support.
        </p>
        <div className="pt-4">
          <CustomButton
            type="button"
            isFilled={true}
            horizontalPaddingClasses="px-4.5"
            verticalPaddingClasses="py-2"
            onClick={() => {
              preserveTableColumn(persist)
              window.location.href = window.location.origin
            }}
            dataQaId={'logout-button-unauthorized-screen'}
          >
            {NAMESPACES.LOGOUT_BUTTON}
          </CustomButton>
        </div>
      </div>
    </div>
  )
}

export default UserNotFoundPage
